import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const languageMap: any = {
  en: { label: "English", dir: "ltr", active: false },
  hn: { label: "हिन्दी", dir: "ltr", active: false },
  bn: { label: "বাংলা", dir: "ltr", active: false },
  kn: { label: "ಕನ್ನಡ", dir: "ltr", active: false },
  ta: { label: "தமிழ்", dir: "ltr", active: false },
};

const LanguageSelect = () => {
  const { t } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(
    (localStorage.getItem("i18nextLng") || "en").split("-")[0]
  );
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedLang) {
      i18next.changeLanguage(selectedLang);
    }
  }, [selectedLang]);

  const handleLangChange = (lang: string) => {
    setSelectedLang(lang);
    i18next.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang);
    setIsOpen(false); // Close the dropdown after selection
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className="select-lang language-select"
      style={{ position: "relative", display: "flex", gap: "2px" }}
    >
      <img
        src="/assets/img/language1.svg"
        alt="Language"
        style={{ marginRight: "8px", cursor: "pointer" }}
        onClick={() => setIsOpen(!isOpen)}
      />

      <div
        className="dropdown"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: "pointer" }}
      >
        <span>{languageMap[selectedLang]?.label}</span>
        <i className="fa fa-angle-down fa-xs ml-2"></i>
      </div>

      {isOpen && (
        <ul
          className="dropdown-list dropdown-menu"
          style={{
            position: "absolute",
            border: "1px solid #ddd",
            listStyle: "none",
            padding: 0,
            width: "100px",
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {Object.keys(languageMap).map((item, index, array) => (
            <li
              key={item}
              onClick={() => handleLangChange(item)}
              style={{
                padding: "5px",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {languageMap[item].label}
              </div>
              {index !== array.length - 1 && <hr style={{ width: "130px" }} />}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelect;
